
import { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trash2 } from "lucide-react";
import { ProcurementFormValues } from "../schema";
import { ItemFormFields } from "./ItemFormFields";

interface ItemCardProps {
  form: UseFormReturn<ProcurementFormValues>;
  index: number;
  item: any;
  itemsCount: number;
  onRemoveItem: (index: number) => void;
}

export const ItemCard = ({ 
  form, 
  index, 
  item, 
  itemsCount, 
  onRemoveItem 
}: ItemCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-4">
        <div className="flex justify-between items-center">
          <CardTitle className="text-base">Product {index + 1}</CardTitle>
          {itemsCount > 1 && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => onRemoveItem(index)}
              className="text-destructive hover:text-destructive"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <ItemFormFields form={form} index={index} item={item} />
      </CardContent>
    </Card>
  );
};
